export class UserInfo {
  corporateName: string;
  postalCode: string;
  address: string;
  tel: string;
  business: string;
  personCharge: string;
  mailAddress: string;
  password: string;
  checkPass: string;
  csrf: string;
  confFlg: boolean;
  mailBackup: string;
  constructor () {
    this.corporateName = ''
    this.postalCode = ''
    this.address = ''
    this.tel = ''
    this.business = ''
    this.personCharge = ''
    this.mailAddress = ''
    this.password = ''
    this.checkPass = ''
    this.csrf = ''
    this.confFlg = false
    this.mailBackup = ''
  }

  clear (): void {
    this.corporateName = ''
    this.postalCode = ''
    this.address = ''
    this.tel = ''
    this.business = ''
    this.personCharge = ''
    this.mailAddress = ''
    this.password = ''
    this.checkPass = ''
    this.csrf = ''
    this.confFlg = false
    this.mailBackup = ''
  }
}
